import { ListItem, Section } from '@/components';
import { useWalletsContext } from '@/components/providers/postauth/UserWalletsProvider';
import { formatNumberToAmountInUsdString } from '@/utils/formatUtils';
import { REWARDS } from '@/utils/strings';
import { FC } from 'react';
import { GiGrowth } from 'react-icons/gi';
interface Props {
  label?: string;
  returnRate?: number | null;
}
const TotalRewardsIcon = GiGrowth as React.ComponentType<any>;
const TotalRewardsSection: FC<Props> = ({ label = REWARDS.LABEL }) => {
  const { totalPortfolioRewardsValueInUsd } = useWalletsContext();
  return (
    <Section
      body={
        <ListItem
          leftIcon={<TotalRewardsIcon className="text-secondary" />}
          leftIconWidth={33}
          leftIconHeight={28}
          mainText={formatNumberToAmountInUsdString(
            totalPortfolioRewardsValueInUsd || 0,
          )}
          mainTextColor={'primary'}
          subText={label}
          subTextSize={'caption'}
        />
      }
    />
  );
};
export default TotalRewardsSection;
